import type { FC, ReactNode } from "react";

import { cn } from "@/lib/utils";

export type ChipTone =
  | "muted"
  | "dashed"
  | "primary"
  | "amber"
  | "destructive"
  | "emerald";

type Props = {
  children: ReactNode;
  tone?: ChipTone;
  className?: string;
  title?: string;
};

/** An 18px inline tag for row metadata: where an answer saves, a rule, an issue. */
export const Chip: FC<Props> = ({
  children,
  tone = "muted",
  className,
  title
}) => (
  <span
    title={title}
    className={cn(
      "inline-flex h-4.5 max-w-full shrink-0 items-center gap-1 truncate rounded px-1.5 text-xs whitespace-nowrap",
      tone === "muted" && "bg-muted text-muted-foreground",
      tone === "dashed" &&
        "border border-dashed border-border text-muted-foreground",
      tone === "primary" && "bg-primary/10 text-primary",
      tone === "amber" && "bg-warn-soft text-warn",
      tone === "destructive" && "bg-destructive/10 text-destructive",
      tone === "emerald" && "bg-success-soft text-success",
      className
    )}
  >
    {children}
  </span>
);
